import React, { useState } from "react";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";




const CustomTamilInput = ({value, setValue, name, disabled}) => {
 //   const [text, setText] = useState("");

    const handleChange = (e) => {
        setValue(e)
    }

    return (<>
        <ReactTransliterate
            value={value}
            onChangeText={setValue}
            lang="ta" 
            name={name}
            placeholder="Enter Tamil text"
            disabled={disabled ? true : false}
            style={{
                width: "100%",
                padding: "7px",
                // fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
            }}
        />
    </>)
}

export default CustomTamilInput; 